import React from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye } from '@fortawesome/free-solid-svg-icons';
import { ToastContainer, toast } from 'react-toastify';

const Question = ({ EachQuestion }) => {
    const { id, correctAnswer, question, options } = EachQuestion;

    const answerMatcher = (value, correctAnswer) => {
        // console.log('answer');
        // console.log(value)
        // console.log(correctAnswer)

        if (value === correctAnswer) {
            toast("Right Answer");

        }
        else {
            toast('Wrong Answer')
        }
    }

    const showCorrectAnswer = () => {
        toast(correctAnswer);
    }
    return (
        <div>
            <div className='border border-indigo-600 w-1/2 mr-auto ml-auto mt-5 p-6 mb-7'>
                <div className='inline-flex gap-6'>
                    <div>
                        <h1 className='font-bold mb-6'> {question}</h1>
                    </div>

                    <div>
                        <button onClick={showCorrectAnswer} className='text-violet-700'>
                            <FontAwesomeIcon className='text-violet-700' icon={faEye}></FontAwesomeIcon>
                        </button>
                    </div>

                </div>
                <div className='grid grid-cols-2 gap-0.5 gap-x-1  gap-y-3'>
                    {
                        options.map(Option =>
                            <div className='inline-flex mr-auto ml-auto p-3 '>
                                <div >
                                    <input type="radio"
                                        name={id}
                                        className="radio"
                                        value={Option}

                                        onClick={(e) => answerMatcher(e.target.value, correctAnswer)}

                                        checked />

                                </div>

                                <h2 className='ml-2'>{Option}</h2>
                            </div>




                        )
                    }
                </div>

            </div>
            {/* <h2>Correct ans is :{correctAnswer}</h2> */}

        </div>
    );
};

export default Question;